var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUparrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84547 0.0984373C3.69567 -0.0328125 3.38112 -0.0328125 3.23132 0.0984373L0.0858318 2.86159C0.0396869 2.90227 0.0108004 2.95126 0.00248899 3.00296C-0.00582244 3.05465 0.00677818 3.10694 0.0388439 3.15383C0.0709097 3.20071 0.121141 3.24029 0.18377 3.26803C0.246398 3.29576 0.318886 3.31051 0.39291 3.3106H1.96565V5.24481C1.96565 5.31809 2.00708 5.38838 2.08081 5.4402C2.15455 5.49201 2.25456 5.52113 2.35884 5.52113H4.71795C4.82223 5.52113 4.92224 5.49201 4.99598 5.4402C5.06971 5.38838 5.11114 5.31809 5.11114 5.24481V3.3106H6.68388C6.75791 3.31051 6.83039 3.29576 6.89302 3.26803C6.95565 3.24029 7.00588 3.20071 7.03795 3.15383C7.07001 3.10694 7.08261 3.05465 7.0743 3.00296C7.06599 2.95126 7.03711 2.90227 6.99096 2.86159L3.84547 0.0984373ZM4.71795 2.75797H4.32477V4.9685H2.75202V2.75797H1.21113L3.5384 0.713515L5.86566 2.75797H4.71795Z",
    fill: "#AEAEAE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.7a17a5cefde3aac58d17cd773768fb42.svg";
export { ForwardRef as ReactComponent };